/* product-page.js */

document.addEventListener("DOMContentLoaded", () => {
  initGallery();
  initVariantPicker();
  initQtyStepper();
  loadAsyncSections();
});

function initGallery() {
  const gallery = document.querySelector("[data-product-gallery]");
  if (!gallery) return;
  const slides = gallery.querySelectorAll("[data-gallery-slide]");
  const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");

  thumbs.forEach(thumb => {
    thumb.addEventListener("click", () => {
      const index = parseInt(thumb.dataset.index, 10);
      slides.forEach((s, i) => s.classList.toggle("active", i === index));
      thumbs.forEach(t => t.classList.remove("active"));
      thumb.classList.add("active");
    });
  });
}

function initVariantPicker() {
  const form = document.querySelector("[data-product-form]");
  if (!form) return;

  const variantInput = form.querySelector("[data-variant-id]");
  const priceEl = document.querySelector("[data-product-price]");
  const stockEl = document.querySelector("[data-stock-status]");
  const addBtn = form.querySelector("[data-add-to-cart]");
  const optionGroups = form.querySelectorAll("[data-option-index]");

  // Product JSON is needed for real variant matching — read it from the
  // handle and fetch once, cached for the life of the page.
  const handle = document.body.dataset.productHandle || document.querySelector("[data-product-handle]")?.dataset.productHandle;
  let productData = null;

  fetch(`/products/${handle}.js`).then(r => r.json()).then(data => {
    productData = data;
    wireOptions();
  });

  function wireOptions() {
    const selections = {};

    optionGroups.forEach(group => {
      const idx = group.dataset.optionIndex;
      const buttons = group.querySelectorAll(".qv-option-btn, .swatch-btn");
      buttons[0]?.classList.add("selected");
      selections[idx] = buttons[0]?.dataset.value;

      buttons.forEach(btn => {
        btn.addEventListener("click", () => {
          buttons.forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");
          selections[idx] = btn.dataset.value;
          updateVariant(selections);
        });
      });
    });

    updateVariant(selections);
  }

  function updateVariant(selections) {
    if (!productData) return;
    const match = productData.variants.find(v =>
      Object.keys(selections).every(i => v[`option${parseInt(i) + 1}`] === selections[i])
    );
    if (!match) return;

    variantInput.value = match.id;

    const money = (cents) => (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "PKR" });
    const onSale = match.compare_at_price > match.price;
    priceEl.innerHTML = `${onSale ? `<span class="old">${money(match.compare_at_price)}</span>` : ""}<span class="new">${money(match.price)}</span>`;

    if (match.available) {
      stockEl.textContent = "In stock";
      stockEl.classList.remove("out-of-stock");
      addBtn.disabled = false;
      addBtn.textContent = "Add to Cart";
    } else {
      stockEl.textContent = "Out of stock";
      stockEl.classList.add("out-of-stock");
      addBtn.disabled = true;
      addBtn.textContent = "Sold Out";
    }
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    addBtn.textContent = "Adding…";
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantInput.value,
          quantity: parseInt(form.querySelector("[data-qty-input]").value, 10) || 1
        })
      });
      document.dispatchEvent(new CustomEvent("cart:updated"));
      addBtn.textContent = "Added ✓";
      setTimeout(() => { addBtn.textContent = "Add to Cart"; }, 1500);
    } catch (err) {
      addBtn.textContent = "Try again";
      console.error(err);
    }
  });
}

function initQtyStepper() {
  document.querySelectorAll(".qty-stepper").forEach(stepper => {
    const input = stepper.querySelector("[data-qty-input]");
    stepper.querySelector("[data-qty-increase]")?.addEventListener("click", () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) + 1);
    });
    stepper.querySelector("[data-qty-decrease]")?.addEventListener("click", () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
    });
  });
}

/* Loads sections async via the Section Rendering API — used for product
   recommendations so they don't block the initial product page render. */
function loadAsyncSections() {
  document.querySelectorAll("[data-section-loader]").forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      el.replaceWith(...wrapper.childNodes);
    } catch (err) {
      console.error("Failed to load section", err);
    }
  });
}
